/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48161Req {
  
  /** 查询planNo */
  planNo?: string;
};



export interface API48161Res {
  /**   */
  htmlText?: string;
  /**   */
  isExternalInvest?: number;
  
};


// 48161 查看商业计划书

export interface IUsePostAPI48161Return {
  /** 查看商业计划书: 接口请求状态 */
  isAPI48161Loading: boolean;
  /** 查看商业计划书: 接口请求返回数据 */
  dataAPI48161: API48161Res;
  /**  查看商业计划书: 接口数据请求方法 */
  fetchAPI48161Data:  (inputs: API48161Req, config?: YWRequestConfig) => Promise<API48161Res>;
  /** 查看商业计划书: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48161 = ():IUsePostAPI48161Return => {
  let isMount = true;
  const [isAPI48161Loading, setIsAPI48161Loading] = useState(false);
  const [dataAPI48161, setDataAPI48161] = useState<API48161Res>({} as API48161Res);
  const requestUrl = `${basePath}/corp-admin/project/plan4biz/doc/detail`;

  const fetchAPI48161Data = async (inputs: API48161Req, config?: YWRequestConfig): Promise<API48161Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48161Req>) || {}) as API48161Req;
    
  
    if ( isMount ) {
      setIsAPI48161Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48161Res>(`${basePath}/corp-admin/project/plan4biz/doc/detail`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48161(res || {} as API48161Res);
        setIsAPI48161Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48161Loading(false);
      }
      return false as unknown as API48161Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48161Loading,
    dataAPI48161,
    fetchAPI48161Data,
    requestUrl,
  }
}

